import reportService from '@/api/report'
import { REPORT } from '../types'
import Vue from 'vue'
import utils from '@/utils/utils.js'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    dateStart: '',
    dateEnd: '',
    roomLocations:[],
    roomLocation:[],
    owners:[],
    eventStatus:[],
    roomEventReports:[],
    isDownloadingFile: false,
  },
  getters:{
    startDate: (state) => {
      return state.dateStart
    },
    endDate: (state) => {
      return state.dateEnd
    },
    roomLocations: (state) => {
      return state.roomLocations
    },
    roomLocation: (state) => {
      return state.roomLocation
    },
    eventStatus: (state) => {
      return state.eventStatus
    },
    roomEventReports: (state) => {
      return state.roomEventReports
    }
  },
  mutations: {
    [REPORT.SET_IS_DOWNLOADING_FILE] (state, value) {
      state.isDownloadingFile = value
    },
    [REPORT.SET_STARTDATE](state, val) {
      state.dateStart = val
    },
    [REPORT.SET_ENDDATE](state, val) {
      state.dateEnd = val
    },
    [REPORT.SET_LOCATIONS] (state, val) {
      state.roomLocations = val
    },
    [REPORT.CLEAR_LOCATIONS](state) {
      state.roomLocations = null
    },
    [REPORT.SELECT_LOCATION](state, val) {
      state.roomLocation = val
    },
    [REPORT.CLEAR_LOCATION] (state) {
      state.roomLocation = null
    },
    [REPORT.SELECT_OWNER] (state, val) {
      state.owners.push(val)
    },
    [REPORT.REMOVE_OWNER] (state, val) {
      state.owners.splice(val, 1)
    },
    [REPORT.CLEAR_OWNER] (state) {
      state.owners = []
    },
    [REPORT.SELECT_EVENT_STATUS] (state, val) {
      state.eventStatus = val
    },
    [REPORT.CLEAR_EVENT_STATUS] (state) {
      state.eventStatus = null
    },
    [REPORT.SET_EVENT_REPORT] (state, roomEventReports) {
      state.roomEventReports = roomEventReports 
    },
    [REPORT.CLEAR_EVENT_REPORT] (state) {
      state.roomEventReports = null 
    }
  },
  actions: {
    setStartDate: function({commit}, val) {
      commit(REPORT.SET_STARTDATE, val)
    },
    setEndDate: function({commit}, val) {
      commit(REPORT.SET_ENDDATE, val)
    },
    setRoomLocations: function({commit}, val) {
      commit(REPORT.SET_LOCATIONS, val)
    },
    selectRoomLocation: function({commit}, val) {
      commit(REPORT.SELECT_LOCATION, val)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(REPORT.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(REPORT.REMOVE_OWNER, index)
    },
    setEventStatus ({ commit }, val) {
      commit(REPORT.SELECT_EVENT_STATUS, val)
    },
    getMonitoringReportToken: async function ({dispatch}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response =  await reportService.getDashboardMonitoringToken()
        return response.data;
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getDashboardRoomToken: async function ({dispatch}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response =  await reportService.getDashboardRoomToken()
        return response.data;
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getFilterRoomEventReport: async function ({commit, dispatch}) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        const response =  await reportService.getFilterRoomEventReport()
        commit(REPORT.SET_LOCATIONS, response.data.locations)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getRoomEventReport: async function ({commit, dispatch, state}) {
      try {
        let emails = []
        state.owners.forEach(owner => {
          emails.push(owner.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          userEmails: emails,
          locationIds: state.roomLocation,
          status: state.eventStatus
        }
        await reportService.getRoomEventReport(filters)
          .then((response) => {
            commit(REPORT.SET_EVENT_REPORT, response.data)
          })
          .catch(() => {
            commit(REPORT.CLEAR_EVENT_REPORT)
          });
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async downloadRoomEventReportFile ({dispatch, state}) {
      try {
        dispatch('setIsDownloadingFile', true)
        let emails = []
        state.owners.forEach(owner => {
          emails.push(owner.email)
        });
        let filters = {
          start: proto.$moment(state.dateStart).utc().format(),
          finish: proto.$moment(state.dateEnd).utc().format(),
          userEmails: emails,
          locationIds: state.roomLocation,
          status: state.eventStatus
        }
          let response = await reportService.getRoomEventReportFile(filters)
          dispatch('setIsDownloadingFile', false)
          let contentType = response.headers['content-type']
          let blob = new Blob([response.data], { type: contentType })
          let contentDisposition = response.headers['content-disposition']
          let fileName = utils.getFileName(contentDisposition)
          utils.handleDownload(blob , fileName)
        } catch (e) {

        dispatch('setIsDownloadingFile', false)
        dispatch('Global/showMessage', 'errorDefault', {root: true})
      }
    },
    setIsDownloadingFile ({commit}, value) {
      commit(REPORT.SET_IS_DOWNLOADING_FILE, value)
    },
    clearData: function ({commit}) {
      commit(REPORT.SET_STARTDATE, '')
      commit(REPORT.SET_ENDDATE, '')
      commit(REPORT.CLEAR_LOCATIONS)
      commit(REPORT.CLEAR_LOCATION)
      commit(REPORT.CLEAR_OWNER)
      commit(REPORT.CLEAR_EVENT_STATUS)
      commit(REPORT.CLEAR_EVENT_REPORT)
    }
  }
}
